import React from "react";

export default function LockIcon(props: React.SVGProps<SVGSVGElement>) {
  return (
    <svg
      {...props}
      viewBox="0 0 12 14"
      fill="none"
      xmlns="http://www.w3.org/2000/svg">
      <path
        d="M10 5H9V3.5C9 1.57 7.43 0 5.5 0C3.57 0 2 1.57 2 3.5V5H1C0.45 5 0 5.45 0 6V13C0 13.55 0.45 14 1 14H10C10.55 14 11 13.55 11 13V6C11 5.45 10.55 5 10 5ZM3.5 3.5C3.5 2.4 4.4 1.5 5.5 1.5C6.6 1.5 7.5 2.4 7.5 3.5V5H3.5V3.5ZM9.5 12.5H1.5V6.5H9.5V12.5ZM5.5 9.75C6.05 9.75 6.5 9.3 6.5 8.75C6.5 8.2 6.05 7.75 5.5 7.75C4.95 7.75 4.5 8.2 4.5 8.75C4.5 9.3 4.95 9.75 5.5 9.75Z"
        fill="currentColor"
      />
    </svg>
  );
}
